module.exports = __webpack_public_path__ + "static/media/cha-1.b90f912.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/audio/cha-1.wav
// module id = RLhk
// module chunks = 1